import React, {useContext, useEffect, useState} from "react";
import {useLocation, useParams} from "react-router-dom";
import AIBanner from "../_components/_global/AIBanner";
import {UserPreferencesContext} from "../_components/common/UserPreferencesContext";
import requestBody from "../data/mockBody";
import DayItineraryUpdated from "../_components/main/DayItineraryUpdated";
import { ActivitiesContext } from "../context/ActivitiesContext";

const DynamicDayPage = () => {
    const { activities, loading, planId } = useContext(ActivitiesContext);


    const { dayNumber } = useParams();
    const { preferences } = useContext(UserPreferencesContext);

    const location = useLocation();
    const tier = location.state?.tier || localStorage.getItem("selectedTier") || "Basic"; // Default to "Basic" if no tier is provided

    return (
        <div>
            {loading && <AIBanner />}
            {activities && activities.length > 0 && (
                <DayItineraryUpdated
                    allActivities={activities}
                    dayNumber={parseInt(dayNumber, 10)}
                    tier={tier}
                    planId={planId} />
            )}
        </div>
    );
};

export default DynamicDayPage;
